module.exports = __webpack_public_path__ + "img/use-hover.eddb6cf7.svg";